module.exports = __webpack_public_path__ + "static/media/icon-down-arrow-dark-grey.0ad38561.svg";